var swiper = new Swiper(".logo-slider-swiper", {
  slidesPerView: 5,
  spaceBetween: 30,
  loop: true,
  // pagination: {
  //   el: ".swiper-pagination",
  //   clickable: true,
  // },
  breakpoints: {
    0: {
      slidesPerView: 2.7,
      spaceBetween: 20,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3.7,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
  },
});

// ..................................................................................................................

var swiper = new Swiper(".featured-product-cards--main", {
  slidesPerView: 3.7,
  spaceBetween: 30,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3.7,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 3.7,
      spaceBetween: 30,
    },
  },
});

// ..................................................................................................................

var swiper = new Swiper(".product-slider-swiper", {
  slidesPerView: 4.7,
  breakpoints: {
    0: {
      slidesPerView: 1.2,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3.7,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 4.4,
      spaceBetween: 30,
    },
  },
});

// ..................................................................................................................

var swiper = new Swiper(".bottom-gallery-slider", {
  spaceBetween: 5,
  centeredSlides: true,
  speed: 3000,
  autoplay: {
    delay: 0,
  },
  loop: true,
  slidesPerView: "auto",
  allowTouchMove: false,
  disableOnInteraction: true,
});

// ..................................................................................................................

var swiper = new Swiper(".as-seen-on-slider", {
  spaceBetween: 5,
  centeredSlides: true,
  speed: 3000,
  autoplay: {
    delay: 0,
  },
  loop: true,
  slidesPerView: "auto",
  allowTouchMove: false,
  disableOnInteraction: true,
});

// ..................................................................................................................























